//bao migrate skip
import * as ko from "knockout";
import * as $ from "jquery";
let bindingName = "inputmask";
export class InputMask {
    //https://github.com/jasny/bootstrap/
    private isIphone = (window.orientation !== undefined);
    private isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
    private isIE = window.navigator.appName == 'Microsoft Internet Explorer';
    private DEFAULTS = {
        mask: "",
        placeholder: "_",
        definitions: {
            '9': "[0-9]",
            'a': "[A-Za-z]",
            'w': "[A-Za-z0-9]",
            'h': "[A-Fa-f0-9]",
            '*': "."
        },
        clear: false
    };
    private setSelectionRange: any;
    private createTextRange: any;
    private $element: JQuery;
    private mask: string;
    private tests: any[];
    private partialPosition: number;
    private firstNonMaskPos: number;
    private buffer: any;
    private focusText: string;
    private options: Bindings.inputmask;
    constructor(private element: HTMLElement, options: Bindings.inputmask) {
        if (this.isAndroid) {
            return; // No support because caret positioning doesn't work on Android
        }
        this.options = $.extend({}, this.DEFAULTS, options);
        this.$element = $(element);
        this.mask = ko.unwrap(this.options.mask);
        this.init();
        this.listen();
        this.checkVal(); //Perform initial check for existing values
    }
    init() {
        var defs = this.DEFAULTS.definitions;
        var len = this.mask.length;
        this.tests = [];
        this.partialPosition = this.mask.length;
        this.firstNonMaskPos = null;
        $.each(this.mask.split(""), $.proxy(function (i, c) {
            if (c == '?') {
                len--;
                this.partialPosition = i;
            }
            else if (defs[c]) {
                this.tests.push(new RegExp(defs[c]));
                if (this.firstNonMaskPos === null) {
                    this.firstNonMaskPos = this.tests.length - 1;
                }
            }
            else {
                this.tests.push(null);
            }
        }, this));
        this.buffer = $.map(this.mask.split(""), $.proxy(function (c, i) {
            if (c != '?') {
                return defs[c] ? this.options.placeholder : c;
            }
        }, this));
        this.focusText = this.$element.val() as string;
        this.$element.data("rawMaskFn", $.proxy(function () {
            return $.map(this.buffer, (c, i) => {
                return this.tests[i] && c != this.options.placeholder ? c : null;
            }).join('');
        }, this));
    }
    ;
    listen() {
        if (this.$element.attr("readonly")) {
            return;
        }
        var pasteEventName = (this.isIE ? 'paste' : 'input') + ".bs.inputmask";
        this.$element
            .on("unmask.bs.inputmask", $.proxy(this.unmask, this))
            .on("focus.bs.inputmask", $.proxy(this.focusEvent, this))
            .on("blur.bs.inputmask", $.proxy(this.blurEvent, this))
            .on("keydown.bs.inputmask", $.proxy(this.keydownEvent, this))
            .on("keypress.bs.inputmask", $.proxy(this.keypressEvent, this))
            .on(pasteEventName, $.proxy(this.pasteEvent, this));
    }
    ;
    //Helper Function for Caret positioning
    caret(begin?: number, end?: number): any {
        if (this.$element.length === 0)
            return;
        if (typeof begin == 'number') {
            end = (typeof end == 'number') ? end : begin;
            return this.$element.each(() => {
                if (this.setSelectionRange) {
                    this.setSelectionRange(begin, end);
                }
                else if (this.createTextRange) {
                    var range = this.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', end);
                    range.moveStart('character', begin);
                    range.select();
                }
            });
        }
        else {
            if (this.$element[0]["setSelectionRange"]) {
                begin = this.$element[0]["selectionStart"];
                end = this.$element[0]["selectionEnd"];
            }
            else if (document["selection"] && document["selection"].createRange) {
                var range = document["selection"].createRange();
                begin = 0 - range.duplicate().moveStart('character', -100000);
                end = begin + range.text.length;
            }
            return {
                begin: begin,
                end: end
            };
        }
    }
    ;
    seekNext(pos) {
        var len = this.mask.length;
        while (++pos <= len && !this.tests[pos])
            ;
        return pos;
    }
    ;
    seekPrev(pos) {
        while (--pos >= 0 && !this.tests[pos])
            ;
        return pos;
    }
    ;
    shiftL(begin, end) {
        var len = this.mask.length;
        if (begin < 0) {
            return;
        }
        for (var i = begin, j = this.seekNext(end); i < len; i++) {
            if (this.tests[i]) {
                if (j < len && this.tests[i].test(this.buffer[j])) {
                    this.buffer[i] = this.buffer[j];
                    this.buffer[j] = this.options.placeholder;
                }
                else {
                    break;
                }
                j = this.seekNext(j);
            }
        }
        this.writeBuffer();
        this.caret(Math.max(this.firstNonMaskPos, begin));
    }
    ;
    shiftR(pos) {
        var len = this.mask.length;
        for (var i = pos, c = this.options.placeholder; i < len; i++) {
            if (this.tests[i]) {
                var j = this.seekNext(i);
                var t = this.buffer[i];
                this.buffer[i] = c;
                if (j < len && this.tests[j].test(t)) {
                    c = t;
                }
                else {
                    break;
                }
            }
        }
    }
    ;
    unmask() {
        this.$element
            .unbind(".bs.inputmask")
            .removeData("bs.inputmask");
    }
    ;
    focusEvent() {
        this.focusText = this.$element.val() as string;
        var len = this.mask.length;
        var pos = this.checkVal();
        this.writeBuffer();
        var moveCaret = () => {
            if (pos == len)
                this.caret(0, pos);
            else
                this.caret(pos);
        };
        moveCaret();
        setTimeout(moveCaret, 50);
    }
    private _ignorePasteEvent = false;
    blurEvent() {
        this.checkVal();
        let isEmpty = this.$element.val() == "";
        if (this.$element.val() !== this.focusText) {
            this._ignorePasteEvent = true; //input event is used in some browsers for pasteEvent so on blur we must ignore it!
            this.$element.trigger('change');
            this.$element.trigger('input');
            this._ignorePasteEvent = false;
        }
    }
    keydownEvent(e) {
        var k = e.which;
        //backspace, delete, and escape get special treatment
        if (k == 8 || k == 46 || (this.isIphone && k == 127)) {
            var pos = this.caret(), begin = pos.begin, end = pos.end;
            if (end - begin === 0) {
                begin = k != 46 ? this.seekPrev(begin) : (end = this.seekNext(begin - 1));
                end = k == 46 ? this.seekNext(end) : end;
            }
            this.clearBuffer(begin, end);
            this.shiftL(begin, end - 1);
            return false;
        }
        else if (k == 27) { //escape
            this.$element.val(this.focusText);
            this.caret(0, this.checkVal());
            return false;
        }
    }
    ;
    keypressEvent(e) {
        var len = this.mask.length;
        var k = e.which, pos = this.caret();
        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) { //Ignore
            return true;
        }
        else if (k) {
            if (pos.end - pos.begin !== 0) {
                this.clearBuffer(pos.begin, pos.end);
                this.shiftL(pos.begin, pos.end - 1);
            }
            var p = this.seekNext(pos.begin - 1);
            if (p < len) {
                var c = String.fromCharCode(k);
                if (this.tests[p].test(c)) {
                    this.shiftR(p);
                    this.buffer[p] = c;
                    this.writeBuffer();
                    var next = this.seekNext(p);
                    this.caret(next);
                }
            }
            return false;
        }
    }
    pasteEvent() {
        if (this._ignorePasteEvent == false) {
            setTimeout(() => {
                this.caret(this.checkVal(true));
            }, 0);
        }
    }
    clearBuffer(start, end) {
        var len = this.mask.length;
        for (var i = start; i < end && i < len; i++) {
            if (this.tests[i]) {
                this.buffer[i] = this.options.placeholder;
            }
        }
    }
    writeBuffer() {
        return this.$element.val(this.buffer.join('')).val();
    }
    checkVal(allow?: boolean) {
        var len = this.mask.length;
        //try to place characters where they belong
        var test = this.$element.val() as string;
        var lastMatch = -1;
        for (var i = 0, pos = 0; i < len; i++) {
            if (this.tests[i]) {
                this.buffer[i] = this.options.placeholder;
                while (pos++ < test.length) {
                    var c = test.charAt(pos - 1);
                    if (this.tests[i].test(c)) {
                        this.buffer[i] = c;
                        lastMatch = i;
                        break;
                    }
                }
                if (pos > test.length) {
                    break;
                }
            }
            else if (this.buffer[i] == test.charAt(pos) && i != this.partialPosition) {
                pos++;
                lastMatch = i;
            }
        }
        if (!allow && lastMatch + 1 < this.partialPosition) {
            if (lastMatch == -1 || this.options.clear) {
                this.$element.val("");
                this.clearBuffer(0, len);
            }
            else {
                this.$element.focus();
            }
        }
        else if (allow || lastMatch + 1 >= this.partialPosition) {
            this.writeBuffer();
            if (!allow) {
                this.$element.val((this.$element.val() as string).substring(0, lastMatch + 1));
            }
        }
        return (this.partialPosition ? i : this.firstNonMaskPos);
    }
}
export class InputMaskBinding {
    private _inputMask: InputMask;
    constructor(element: HTMLElement, valueAccessor: () => Bindings.inputmask, viewModel: any) {
        this.Element = element;
        this.ValueAccessor = valueAccessor;
        $(this.Element).data("binding_" + bindingName, this);
        this._inputMask = new InputMask(element, ko.map.toJS(valueAccessor()));
    }
    Element: HTMLElement;
    ValueAccessor: () => Bindings.inputmask;
    dispose() {
        $(this.Element).removeData("binding_" + bindingName);
        this._inputMask.unmask();
    }
}
//Knockout register logic for binding and extender
var binding: KnockoutBindingHandler = {
    init: function (element: HTMLElement, valueAccessor, allBindingsAccessor, viewModel) {
        var bindingInstance = new InputMaskBinding(element, valueAccessor, viewModel);
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            bindingInstance.dispose();
        });
    },
    after: ["baoAutoComplete", "baoSearcher", "baoDateTimePicker"]
};
ko.bindingHandlers[bindingName] = binding;